<template>
    <v-container style="margin-bottom: 22px;">
        <v-row>
            <v-col cols="12">
                <UserProfileDisplay :data="data" :patientinfo="mappedPatientInfo" :useData="useData"></UserProfileDisplay>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" style="margin-top: 1rem;" class="mb-4 px-4" >
                <div style="border-radius: 12px; background-color: black; display: flex; justify-content: flex-end; align-items: center; gap: 0.5rem; flex-wrap: wrap;" class="pa-4">
                    <v-btn
                        color="info"
                        @click="loadReportsHistory(); dialogHistory = true"
                    ><v-icon>mdi-history</v-icon></v-btn>
                    <v-btn
                        color="info"
                        class="print-btn"
                        @click="handlePrint"
                        :disabled="!form.id"
                    ><v-icon>mdi-printer</v-icon></v-btn>
                    <v-btn
                        color="warning"
                        @click="handleClear"
                    >
                        <v-icon>mdi-eraser</v-icon>
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="handleSave"
                        :loading="saving"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col cols="12">
                <v-card style="background-color: #FFF; border-radius: 12px;" class="pa-4">
                    <v-card-title class="headline mb-4">Reporte Clínico</v-card-title>
                    <v-card-text>
                        <v-form ref="clinicalReportForm" v-model="valid" lazy-validation>
                        <!-- Date Picker -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <DatePicker 
                                    v-model="form.date"
                                    label="Fecha del Reporte"
                                    :required="true"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.clinicalReportCorrelative"
                                    label="Correlativo"
                                    hint="Escriba las iniciales o prefijo y presione el icono para buscar el siguiente"
                                    persistent-hint
                                    outlined
                                    dense
                                    append-outer-icon="mdi-counter"
                                    @click:append-outer="refreshClinicalReportCorrelative"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientDoctor"
                                    label="Nombre del Veterinario"
                                    outlined
                                    dense
                                />
                            </v-col>
                        </v-row>

                        <!-- Patient Details -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientName"
                                    label="Nombre del Paciente"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientSpecies"
                                    label="Especie"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientBreed"
                                    label="Raza"
                                    outlined
                                    dense
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientGender"
                                    label="Género"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.referringDoctor"
                                    label="Dr. que lo remite"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.originVeterinary"
                                    label="Veterinaria de procedencia"
                                    outlined
                                    dense
                                />
                            </v-col>
                        </v-row>

                        <!-- Quill Editors -->
                        <!-- Additional Patient Info -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.patientAge"
                                    label="Edad del Paciente"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <DatePicker 
                                    v-model="form.patientAdmissionDate"
                                    label="Fecha de Ingreso"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox
                                    v-model="form.examType"
                                    :items="examTypeOptions"
                                    label="Tipo de Examen"
                                    outlined
                                    dense
                                    clearable
                                    :rules="requiredRules"
                                />
                            </v-col>
                            <v-col v-if="isManualExamType" cols="12" md="4">
                                <v-text-field
                                    v-model="form.manualExamType"
                                    label="Tipo de examen manual"
                                    outlined
                                    dense
                                    :rules="requiredRules"
                                />
                            </v-col>
                        </v-row>

                        <!-- Quill Editors -->
                        <v-row>
                            <v-col cols="12">
                                <label>DESCRIPCIÓN DEL CASO: </label>
                                <div :class="['quill-wrapper', { 'quill-wrapper--error': showValidationErrors && isRichTextEmpty(form.description) }]">
                                    <quill-editor
                                        v-model="form.description"
                                        :options="quillOptions"
                                    ></quill-editor>
                                </div>
                                <div v-if="showValidationErrors && isRichTextEmpty(form.description)" class="validation-error">
                                    El campo es requerido
                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <label>DX CLÍNICO: </label>
                                <v-text-field
                                    v-model="form.clinicalDiagnosis"
                                    outlined
                                    dense
                                    multiline
                                    rows="3"
                                    :rules="requiredRules"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <label>DIAGNÓSTICO: </label>
                                <v-text-field
                                    v-model="form.diagnosis"
                                    outlined
                                    dense
                                    multiline
                                    rows="3"
                                    :rules="requiredRules"
                                />
                            </v-col>
                        </v-row>

                        <!-- Images Section -->
                        <v-row class="mt-4 mb-6">
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title class="subtitle-1">
                                        Imágenes del Reporte
                                    </v-card-title>
                                    <v-card-text>
                                        <DxDataGrid
                                            v-if="allImages.length > 0"
                                            key-expr="uniqueId"
                                            :data-source="allImages"
                                            :show-borders="true"
                                            :paging="{ enabled: true, pageSize: 5 }"
                                            class="clinical-images-grid"
                                        >
                                            <DxColumn :width="60" cell-template="image-view-template" caption=""></DxColumn>
                                            <DxColumn :width="80" cell-template="thumbnail-template" caption="Previsualización"></DxColumn>
                                            <DxColumn data-field="Picture" caption="Nombre Archivo"/>
                                            <DxColumn cell-template="description-template" caption="Descripción"/>
                                            <DxColumn :width="60" cell-template="status-template" caption="Estado"/>
                                            <DxColumn :width="60" cell-template="image-delete-template" caption=""></DxColumn>
                                            
                                            <template #thumbnail-template="{ data }">
                                                <img 
                                                    :src="data.data.displayPath" 
                                                    alt="thumbnail"
                                                    class="thumbnail-preview"
                                                    @click="openImageView(data.data.displayPath)"
                                                    style="cursor: pointer;"
                                                />
                                            </template>
                                            
                                            <template #image-view-template="{ data }">
                                                <a href="#" @click.prevent.stop="openImageView(data.data.displayPath)">
                                                    <v-icon color="primary" small>mdi-eye</v-icon>
                                                </a>
                                            </template>

                                            <template #status-template="{ data }">
                                                <v-chip 
                                                    v-if="data.data.isTemp"
                                                    small
                                                    color="warning"
                                                    text-color="white"
                                                >
                                                    Temporal
                                                </v-chip>
                                                <v-chip 
                                                    v-else
                                                    small
                                                    color="success"
                                                    text-color="white"
                                                >
                                                    Guardada
                                                </v-chip>
                                            </template>

                                            <template #description-template="{ data }">
                                                <v-textarea
                                                    :value="data.data.image_description"
                                                    label="Descripción de la imagen"
                                                    outlined
                                                    dense
                                                    rows="2"
                                                    auto-grow
                                                    hide-details
                                                    @input="updateImageDescription(data.data, $event)"
                                                ></v-textarea>
                                            </template>
                                            
                                            <template #image-delete-template="{ data }">
                                                <a href="#" @click.prevent.stop="deleteImage(data.data)">
                                                    <v-icon color="error" small>mdi-delete</v-icon>
                                                </a>
                                            </template>
                                        </DxDataGrid>
                                        <div v-else class="text-center py-4">
                                            <p class="text-muted">No hay imágenes adjuntas</p>
                                        </div>
                                        <v-btn 
                                            color="info"
                                            small
                                            @click="addImagesDialog = true"
                                            class="mt-3"
                                        >
                                            <v-icon left>mdi-plus</v-icon>
                                            Agregar Imágenes
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- Actions -->
                        <v-row class="mt-4">
                            <v-col cols="12" md="3">
                                <v-btn 
                                    color="primary"
                                    block
                                    @click="handleSave"
                                    :loading="saving"
                                >
                                    <v-icon left>mdi-content-save</v-icon>
                                    Guardar Reporte
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-btn 
                                    color="secondary"
                                    block
                                    @click="handlePrint"
                                    :disabled="!form.id"
                                >
                                    <v-icon left>mdi-printer</v-icon>
                                    Imprimir
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-btn 
                                    color="warning"
                                    block
                                    @click="handleClear"
                                >
                                    <v-icon left>mdi-eraser</v-icon>
                                    Limpiar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-btn 
                                    color="info"
                                    block
                                    @click="loadReportsHistory(); dialogHistory = true"
                                >
                                    <v-icon left>mdi-history</v-icon>
                                    Ver Historial
                                </v-btn>
                            </v-col>
                        </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Print Hidden Content -->
        <div ref="dataprint" class="d-none">
            <div class="print-container" style="padding: 0; font-family: Arial, sans-serif;">
                <!-- Header -->
                <div v-if="header" v-html="header" class="report-template-header"></div>
                <div v-else class="report-header">
                    <div class="header-left">
                        <h2>{{ businessName }}</h2>
                        <p>{{ branchName }}</p>
                    </div>
                    <div class="header-right" v-if="logo">
                        <img :src="logo" alt="Logo" class="header-logo">
                    </div>
                </div>
                <!--p class="report-title">
                    REPORTE CLÍNICO
                </p-->
                <div :class="['report-wrapper', { 'report-wrapper--full': imageLayout.primaryImages.length === 0 }]">
                    <!-- Left Column: Main Content -->
                    <div class="content-column">

                        <div v-if="form.clinicalReportCorrelative" class="report-correlative">
                            {{ form.clinicalReportCorrelative }}
                        </div>

                        <!-- Report ID -->
                        <!-- <div class="report-id-section" v-if="form.id || form.reportNumber">
                            <p class="report-id">ID: {{ form.id }} <span v-if="form.reportNumber">/ {{ form.reportNumber }}</span></p>
                        </div> -->

                        <!-- Patient Information Table -->
                        <table class="patient-info-table">
                            <tr>
                                <td colspan="2"><strong>PACIENTE</strong> {{ form.patientName }}</td>
                            </tr>
                            <tr>
                                <td><strong>EDAD</strong> {{ form.patientAge }}</td>
                                <td><strong>ESPECIE:</strong> {{ form.patientSpecies }}</td>
                            </tr>
                            <tr>
                                <td><strong>SEXO</strong> {{ form.patientGender }}</td>
                                <td><strong>RAZA:</strong> {{ form.patientBreed }}</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>MEDICO</strong> {{ form.referringDoctor || "" }}</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>DX.CLINICO</strong> {{ form.clinicalDiagnosis }}</td>
                            </tr>
                            <tr v-if="form.originVeterinary">
                                <td colspan="2"><strong>VETERINARIA</strong> {{ form.originVeterinary }}</td>
                            </tr>
                        </table>

                        <!-- Exam Type Highlighted -->
                        <div class="exam-type-section" v-if="form.examType">
                            <strong>TIPO DE EXAMEN:</strong>
                            <span>{{ form.examType }}</span>
                        </div>

                        <p v-if="form.patientAdmissionDate" class="admission-date">
                            <strong>FECHA DE INGRESO</strong> {{ form.patientAdmissionDate }}
                        </p>

                        <!-- Description Section -->
                        <div class="report-section">
                            <div v-html="form.description" class="section-content"></div>
                        </div>

                    <!-- Diagnosis with Highlight -->
                    <div class="report-section diagnosis-section">
                        <h4>DIAGNOSTICO</h4>
                        <div class="diagnosis-content">{{ form.diagnosis }}</div>
                    </div>
                </div>

                <!-- Right Column: Primary Images (≤3) -->
                <div class="images-column" v-if="imageLayout.primaryImages.length > 0">
                    <div class="image-column">
                        <div v-for="image in imageLayout.primaryImages" :key="image.ID_Image" class="image-item">
                            <div class="image-box">
                                <img :src="image.Path" :alt="'Imagen ' + image.ID_Image">
                            </div>
                            <p v-if="image.image_description" class="image-caption">
                                {{ image.image_description }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Grid Images (>3): Full Width Below -->
            <div v-if="imageLayout.gridImages.length > 0" class="grid-images-section">
                <h4>Imágenes Adicionales</h4>
                <div class="image-grid">
                    <div v-for="image in imageLayout.gridImages" :key="image.ID_Image" class="image-item">
                        <div class="image-box">
                            <img :src="image.Path" :alt="'Imagen ' + image.ID_Image">
                        </div>
                        <p v-if="image.image_description" class="image-caption">
                            {{ image.image_description }}
                        </p>
                    </div>
                </div>
            </div>

                <!-- Signature and Seal Section -->
                <div class="signature-section">
                    <table class="signature-table">
                        <tr>
                            <td class="signature-cell">
                                <div class="signature-box">
                                    <img
                                        v-if="signatureSealSrc"
                                        :src="signatureSealSrc"
                                        alt="Firma"
                                        class="signature-seal"
                                        crossorigin="anonymous"
                                    >
                                    <div class="signature-line"></div>
                                </div>
                                <p class="signature-name">{{ form.patientDoctor }}</p>
                                <p class="signature-label">Firma del Veterinario</p>
                            </td>
                            <td class="timestamp-cell">
                                <p class="timestamp-label">Fecha/Hora del Reporte</p>
                                <p class="timestamp-value">{{ getCurrentTimestamp() }}</p>
                            </td>
                        </tr>
                    </table>
                </div>
                <div v-if="footer" v-html="footer" class="report-footer"></div>
            </div>
        </div>

        <!-- History Dialog -->
        <v-dialog v-model="dialogHistory" max-width="1400px" fullscreen-on-mobile>
            <v-card>
                <v-card-title>Historial de Reportes Clínicos</v-card-title>
                <v-card-text>
                    <DxDataGrid
                        key-expr="id"
                        :data-source="historyData"
                        :show-borders="true"
                        :paging="{ enabled: true, pageSize: 10 }"
                        class="history-datagrid"
                    >
                        <DxColumn :width="60" cell-template="action-template" caption=""></DxColumn>
                        <DxColumn data-field="clinical_report_correlative" caption="Correlativo"/>
                        <DxColumn data-field="Report_Date" caption="Fecha"/>
                        <DxColumn data-field="PatientName" caption="Paciente"/>
                        <DxColumn data-field="ExamType" caption="Tipo de examen"/>
                        <DxColumn data-field="Diagnosis" caption="Diagnostico"/>
                        <DxColumn data-field="PatientDoctor" caption="Veterinario"/>
                        <DxColumn data-field="FullName" caption="Creado por"/>
                        <DxColumn :width="60" cell-template="delete-template" caption=""></DxColumn>

                        <template #action-template="{ data }">
                            <a href="#" class="mr-2" @click.prevent.stop="loadReportAndClose(data.data)">
                                <v-icon color="primary" small>mdi-eye</v-icon>
                            </a>
                        </template>

                        <template #delete-template="{ data }">
                            <a href="#" @click.prevent.stop="openDeleteConfirm(data.data)">
                                <v-icon color="error" small>mdi-delete</v-icon>
                            </a>
                        </template>
                    </DxDataGrid>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialogHistory = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Add Clinical Images Dialog -->
        <AddClinicalImages 
            :visible="addImagesDialog"
            :reportId="form.id"
            :isNewReport="!form.id"
            @imagesSelected="handleImagesSelected"
            @close="addImagesDialog = false"
        />

        <!-- Image Preview Dialog -->
        <v-dialog v-model="imageViewDialog" max-width="800px">
            <v-card>
                <v-card-text class="pa-0">
                    <v-img 
                        :src="selectedImagePath" 
                        max-height="600px"
                        contain
                    ></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="imageViewDialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="deleteConfirmDialog" max-width="400px">
            <v-card>
                <v-card-title>Confirmar Borrado</v-card-title>
                <v-card-text>
                    <p>¿Estás seguro de que deseas eliminar este reporte clínico?</p>
                    <p v-if="reportToDelete" class="text-muted" style="font-size: 0.9em; margin-top: 8px;">
                        <strong>Paciente:</strong> {{ reportToDelete.PatientName }}<br>
                        <strong>Fecha:</strong> {{ reportToDelete.Report_Date }}
                    </p>
                    <p class="text-danger" style="font-size: 0.85em; margin-top: 12px;">
                        Esta acción no se puede deshacer.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="deleteConfirmDialog = false">Cancelar</v-btn>
                    <v-btn color="error" @click="deleteReport()">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Alerts -->
        <alerts v-if="alert.show" v-on:close_alert="closeAlert" :properties="alert"></alerts>
    </v-container>
</template>

<script>
import 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { DxDataGrid, DxColumn  } from 'devextreme-vue/data-grid'
import DatePicker from '@/components/DatePicker'
import Alerts from '@/components/Alerts'
import AddClinicalImages from '@/components/VeterinaryImage/addClinicalImages'
import UserProfileDisplay from '@/components/Displays/UserProfileDisplay.vue'

export default {
    name: 'ClinicalReports',
    components: {
        UserProfileDisplay,
        DatePicker,
        alerts: Alerts,
        DxDataGrid,
        DxColumn,
        AddClinicalImages
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        win: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            valid: false,
            showValidationErrors: false,
            requiredRules: [
                v => !!(v && String(v).trim()) || 'El campo es requerido'
            ],
            form: {
                id: null,
                date: null,
                clinicalReportCorrelative: '',
                patientName: '',
                patientSpecies: '',
                patientBreed: '',
                patientGender: '',
                patientDoctor: '',
                referringDoctor: '',
                originVeterinary: '',
                description: '',
                clinicalDiagnosis: '',
                diagnosis: '',
                patientAge: '',
                patientAdmissionDate: '',
                examType: '',
                manualExamType: '',
                reportNumber: ''
            },
            examTypeOptions: [
                'Citologías',
                'CAAF',
                'Biopsias',
                'Citologías hemáticas',
                'Manual / Otro'
            ],
            saving: false,
            dialogHistory: false,
            historyData: [],
            useData: null,
            header: '',
            footer: '',
            alert: {
                show: false,
                type: 'success',
                header: '',
                body: ''
            },
            clinicalReportImages: [],
            tempReportImages: [],
            addImagesDialog: false,
            imageViewDialog: false,
            selectedImagePath: '',
            deleteConfirmDialog: false,
            reportToDelete: null,
            quillOptions: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        'bold', 'italic', 'underline', 'strike',
                        { 'list': 'ordered'}, { 'list': 'bullet' },
                        'clean'
                    ]
                }
            }
        }
    },
    computed: {
        mappedPatientInfo() {
            // Map the data structure to what UserProfileDisplay expects
            if (!this.data) return null
            return {
                id_patient: this.data.ID_Patient,
                namepatient: this.data.NamePatient,
                dateofbirth: this.data.DateOfBirth,
                species: this.data.Species,
                breed: this.data.Breed,
                ProfilePicPath: this.data.ProfilePicPath,
                customer: this.data.customer || {
                    FirstName: this.data.CustomerFirstName || '',
                    LastName: this.data.CustomerLastName || '',
                    BusinessName: this.data.CustomerBusinessName || '',
                    Is_a_Business: this.data.Is_a_Business || false
                }
            }
        },
        logo() {
            const logoB64 = localStorage.getItem("LogoBranchBase64")
            return logoB64 || null
        },
        businessName() {
            const userinfo = JSON.parse(localStorage.getItem("user"))
            return userinfo.business || 'Negocio'
        },
        branchName() {
            const branchinfo = JSON.parse(localStorage.getItem("branch"))
            return branchinfo.BranchName || 'Sucursal'
        },
        signatureSealSrc() {
            try {
                const user = JSON.parse(localStorage.getItem("user") || "{}")
                const seal = user.seal || ""

                if (!seal) {
                    return ""
                }

                return seal.startsWith("data:image")
                    ? seal
                    : `data:image/png;base64,${seal}`
            } catch (error) {
                return ""
            }
        },
        allImages() {
            // Combine saved and temporary images
            const saved = this.clinicalReportImages.map(img => ({
                ...img,
                uniqueId: `saved-${img.ID_Image}`,
                isTemp: false,
                displayPath: img.Path,
                image_description: img.image_description || ''
            }))
            const temp = this.tempReportImages.map((img, idx) => ({
                uniqueId: `temp-${idx}`,
                Picture: img.file.name,
                displayPath: img.preview,
                image_description: img.image_description || '',
                isTemp: true,
                tempIndex: idx
            }))
            return [...saved, ...temp]
        },
        imageLayout() {
            // Split images: ≤3 in column layout, >3 show first 3 in column + rest in grid
            const total = this.clinicalReportImages.length
            if (total === 0) {
                return { primaryImages: [], gridImages: [] }
            }
            if (total <= 3) {
                return { primaryImages: this.clinicalReportImages, gridImages: [] }
            }
            // >3 images: first 3 in column, rest in grid
            return {
                primaryImages: this.clinicalReportImages.slice(0, 3),
                gridImages: this.clinicalReportImages.slice(3)
            }
        },
        isManualExamType() {
            return this.form.examType === 'Manual / Otro'
        }
    },
    watch: {
        data: {
            handler() {
                this.loadFormDefaults()
            },
            deep: true
        }
    },
    mounted() {
        this.useData = JSON.parse(localStorage.getItem('user'))
        this.loadFormDefaults()
        this.getHeaderFooterTemplates()
    },
    methods: {
        getHeaderFooterTemplates() {
            const user = this.useData || JSON.parse(localStorage.getItem('user') || '{}')
            const search = {
                ID_Branch: user.branch,
                ID_Business: user.businessid
            }

            this.$API.HF.getHF(search).then((data) => {
                const header = data.filter((x) => x?.State == '1' && x?.Type == 'Header')
                const footer = data.filter((x) => x?.State == '1' && x?.Type == 'Footer')
                this.header = header.length > 0
                    ? this.cleanPrintTemplateHtml(JSON.parse(header[0].Body).html, true)
                    : ''
                this.footer = footer.length > 0
                    ? this.cleanPrintTemplateHtml(JSON.parse(footer[0].Body).html, true)
                    : ''
            }).catch(() => {
                this.header = ''
                this.footer = ''
            })
        },

        cleanPrintTemplateHtml(html, preferTextContent = false) {
            if (!html) return ''

            try {
                const parser = new DOMParser()
                const documentHtml = parser.parseFromString(html, 'text/html')
                const textContent = Array.from(documentHtml.querySelectorAll('div[style]'))
                    .find(element => {
                        const style = element.getAttribute('style') || ''
                        return style.includes('font-size') && style.includes('word-wrap')
                    })

                if (preferTextContent && textContent) {
                    return textContent.innerHTML
                        .replace(/<p>\s*(<br\s*\/?>)?\s*<\/p>/gi, '')
                        .trim()
                }

                const mainContent = documentHtml.querySelector('.u-row-container') || documentHtml.body
                const wrapper = document.createElement('div')

                wrapper.innerHTML = mainContent ? mainContent.innerHTML : html

                wrapper.querySelectorAll('style, meta, title, link, script').forEach(element => {
                    element.remove()
                })

                wrapper.querySelectorAll('*').forEach(element => {
                    element.removeAttribute('xmlns')
                    element.removeAttribute('xmlns:v')
                    element.removeAttribute('xmlns:o')
                    element.removeAttribute('class')
                })

                return wrapper.innerHTML
                    .replace(/<!DOCTYPE[\s\S]*?>/gi, '')
                    .replace(/<!--[\s\S]*?-->/g, '')
                    .replace(/<\/?(html|head|body)[^>]*>/gi, '')
                    .trim()
            } catch (error) {
                return html
                    .replace(/<!DOCTYPE[\s\S]*?>/gi, '')
                    .replace(/<!--[\s\S]*?-->/g, '')
                    .replace(/<head[\s\S]*?<\/head>/gi, '')
                    .replace(/<\/?(html|body)[^>]*>/gi, '')
                    .trim()
            }
        },

        calculatePatientAge(dateOfBirthString) {
            if (!dateOfBirthString) return ''
            try {
                const [day, month, year] = dateOfBirthString.split('/').map(Number)
                const birthDate = new Date(year, month - 1, day)
                const today = new Date()
                let age = today.getFullYear() - birthDate.getFullYear()
                const monthDiff = today.getMonth() - birthDate.getMonth()
                
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
                    age--
                }
                
                return age.toString()
            } catch (error) {
                return ''
            }
        },

        getCurrentTimestamp() {
            const now = new Date()
            const day = String(now.getDate()).padStart(2, '0')
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const year = now.getFullYear()
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
        },

        getPatientAdmissionDate() {
            return new Date().toLocaleDateString('es-ES');
        },

        async loadFormDefaults() {
            if (this.data) {
                this.form = {
                    id: null,
                    date: new Date().toLocaleDateString('es-ES'),
                    clinicalReportCorrelative: '',
                    patientName: this.data.NamePatient || '',
                    patientSpecies: this.data.Species || '',
                    patientBreed: this.data.Breed || '',
                    patientGender: this.data.Gender || '',
                    patientDoctor: (this.useData && this.useData.firstName && this.useData.lastName) 
                        ? `${this.useData.firstName} ${this.useData.lastName}` 
                        : '',
                    referringDoctor: '',
                    originVeterinary: '',
                    description: '',
                    clinicalDiagnosis: '',
                    diagnosis: '',
                    patientAge: this.calculatePatientAge(this.data.DateOfBirth),
                    patientAdmissionDate: this.getPatientAdmissionDate(),
                    examType: '',
                    manualExamType: '',
                    reportNumber: ''
                }

                await this.loadNextClinicalReportCorrelative(false)
            }
        },

        async loadNextClinicalReportCorrelative(showError = true) {
            try {
                const response = await this.$API.clinicalreports.getNextCorrelative(this.form.clinicalReportCorrelative)
                this.form.clinicalReportCorrelative = response.clinical_report_correlative || ''
            } catch (error) {
                if (showError) {
                    this.showAlert(
                        'warning',
                        'Advertencia',
                        'No se pudo generar el siguiente correlativo'
                    )
                }
            }
        },

        async refreshClinicalReportCorrelative() {
            await this.loadNextClinicalReportCorrelative(true)
        },

        handleClear() {
            this.saving = false
            this.showValidationErrors = false
            this.loadFormDefaults()
            this.tempReportImages = []
            this.clinicalReportImages = []
            if (this.$refs.clinicalReportForm) {
                this.$refs.clinicalReportForm.resetValidation()
            }
        },

        isRichTextEmpty(value) {
            if (!value) return true

            const plainText = value
                .replace(/<[^>]*>/g, ' ')
                .replace(/&nbsp;/gi, ' ')
                .trim()

            return !plainText
        },

        getExamTypeValue() {
            if (this.isManualExamType) {
                return String(this.form.manualExamType || '').trim()
            }

            return this.form.examType
        },

        async handleSave() {
            this.showValidationErrors = true

            if (!this.form.date || !this.data) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'Por favor completa los campos requeridos'
                )
                return
            }

            const isFormValid = this.$refs.clinicalReportForm
                ? this.$refs.clinicalReportForm.validate()
                : true

            if (!isFormValid || this.isRichTextEmpty(this.form.description)) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'Debes completar los campos requeridos antes de guardar'
                )
                return
            }

            if (this.isManualExamType && !String(this.form.manualExamType || '').trim()) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'Debes escribir el tipo de examen manual'
                )
                return
            }

            this.saving = true
            try {
                const payload = {
                    patient: this.data.ID_Patient,
                    user: this.useData.id,
                    date: this.form.date,
                    clinicalReportCorrelative: this.form.clinicalReportCorrelative,
                    referringDoctor: this.form.referringDoctor,
                    originVeterinary: this.form.originVeterinary,
                    patientName: this.form.patientName,
                    patientSpecies: this.form.patientSpecies,
                    patientBreed: this.form.patientBreed,
                    patientGender: this.form.patientGender,
                    patientDoctor: this.form.patientDoctor,
                    description: this.form.description,
                    ClinicalDiagnosis: this.form.clinicalDiagnosis,
                    diagnosis: this.form.diagnosis,
                    patientAge: this.form.patientAge,
                    patientAdmissionDate: this.form.patientAdmissionDate,
                    examType: this.getExamTypeValue(),
                    reportNumber: this.form.reportNumber,
                    images: this.clinicalReportImages.map(image => ({
                        ID_Image: image.ID_Image,
                        image_description: image.image_description || ''
                    }))
                }

                if (this.form.id) {
                    // Update existing report
                    await this.$API.clinicalreports.updatereport(this.form.id, payload)
                    this.form.examType = payload.examType
                    this.form.manualExamType = ''
                    this.showAlert(
                        'success',
                        'Éxito',
                        'Reporte actualizado correctamente'
                    )
                } else {
                    // Create new report with optional images
                    if (this.tempReportImages.length > 0) {
                        // Build FormData with images
                        const formData = new FormData()
                        const typeOfImage = 'Reportes clínicos'
                        
                        // Add files
                        this.tempReportImages.forEach(imgData => {
                            formData.append('file', imgData.file)
                            formData.append('types', typeOfImage)
                        })

                        // Add report data
                        formData.append('reportData', JSON.stringify(payload))
                        formData.append('imageDescriptions', JSON.stringify(
                            this.tempReportImages.map(imgData => imgData.image_description || '')
                        ))
                        
                        // Add image metadata
                        formData.append('form', JSON.stringify({
                            ID_Patient: this.data.ID_Patient,
                            ImagesDate: new Date().toLocaleDateString('es-ES'),
                            TypeOfImage: typeOfImage,
                            ID_User_Insert: this.useData.id,
                            ID_Business: localStorage.businessName,
                            ID_Branch: localStorage.branchName
                        }))

                        // Create with images (transactional)
                        const response = await this.$API.clinicalreports.createreport(formData, true)
                        this.form.id = response.id
                        this.form.clinicalReportCorrelative = response.clinical_report_correlative || this.form.clinicalReportCorrelative
                        this.form.examType = payload.examType
                        this.form.manualExamType = ''
                        this.tempReportImages = []
                        
                        this.showAlert(
                            'success',
                            'Éxito',
                            'Reporte creado con imágenes correctamente'
                        )
                    } else {
                        // Create without images
                        const response = await this.$API.clinicalreports.createreport(payload)
                        this.form.id = response.id
                        this.form.clinicalReportCorrelative = response.clinical_report_correlative || this.form.clinicalReportCorrelative
                        this.form.examType = payload.examType
                        this.form.manualExamType = ''
                        
                        this.showAlert(
                            'success',
                            'Éxito',
                            'Reporte creado correctamente'
                        )
                    }
                }

                // Load images for this report
                await this.loadReportImages(this.form.id)
                this.$store.commit('vetPatientData/setReloaders', 'ClinicalReports')
                this.showValidationErrors = false

            } catch (error) {
                this.showAlert(
                    'danger',
                    'Error',
                    error || 'Error al guardar el reporte'
                )
            } finally {
                this.saving = false
            }
        },

        getPrintStyles() {
            return `
                * { box-sizing: border-box; }

                @page {
                    size: letter;
                    margin: 0.5in;
                }

                body {
                    font-family: "Courier New", Courier, monospace;
                    margin: 0;
                    padding: 0;
                    line-height: 1.18;
                    background: #fff;
                }

                .print-container {
                    width: 100%;
                    padding: 0 0 90px 0 !important;
                    font-family: "Courier New", Courier, monospace;
                }

                p {
                    margin: 0 0 2px 0;
                }

                table {
                    margin-bottom: 5px;
                    border-collapse: collapse;
                    width: 100%;
                }

                td {
                    padding: 1px 2px;
                    border: none;
                }

                h4 {
                    margin: 5px 0 4px 0;
                    page-break-after: avoid;
                    font-size: 0.9em;
                }

                h2 {
                    margin: 0 0 4px 0;
                    page-break-after: avoid;
                }

                .report-header {
                    display: grid;
                    grid-template-columns: 1fr auto;
                    gap: 12px;
                    align-items: center;
                    margin-bottom: 4px;
                }

                .report-template-header {
                    width: 100%;
                    margin: 0 0 10px 0;
                    padding: 0 0 4px 0;
                    page-break-inside: avoid;
                    break-inside: avoid;
                }

                .report-template-header > * {
                    margin-top: 0 !important;
                    padding-top: 0 !important;
                }

                .header-left {
                    text-align: left;
                }

                .header-right {
                    text-align: right;
                }

                .header-logo {
                    max-height: 82px;
                    object-fit: contain;
                }

                .report-title {
                    font-weight: bold;
                    margin: 6px 0 8px 0;
                    text-align: center;
                    letter-spacing: 0;
                }

                /* Report ID Section */
                .report-id-section {
                    text-align: center;
                    margin-bottom: 8px;
                    padding: 4px;
                    border-bottom: 1px solid #ccc;
                }

                .report-id {
                    font-weight: bold;
                    font-size: 0.95em;
                    margin: 0;
                }

                .report-correlative {
                    margin: 0 0 6px 0;
                    font-size: 13pt;
                    font-weight: 800;
                    letter-spacing: 0;
                }

                /* Patient Info Table */
                .patient-info-table {
                    margin-bottom: 4px;
                    font-size: 11pt;
                    text-transform: uppercase;
                }

                .patient-info-table td {
                    padding: 1px 4px 3px 0;
                    vertical-align: baseline;
                }

                .patient-info-table strong {
                    display: inline-block;
                    min-width: 82px;
                    font-size: 12pt;
                    font-weight: 800;
                }

                /* Exam Type Highlighted Section */
                .exam-type-section {
                    display: grid;
                    grid-template-columns: 160px 1fr;
                    align-items: center;
                    gap: 4px;
                    margin: 4px 0 6px 0;
                    border-radius: 0;
                    page-break-inside: avoid;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }

                .exam-type-section strong {
                    font-size: 11pt;
                    font-weight: 800;
                }

                .exam-type-section span {
                    display: block;
                    background-color: #c9b2f2;
                    color: #c86400;
                    font-weight: 800;
                    text-align: center;
                    padding: 3px 6px;
                    min-height: 18px;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }

                .exam-type-label {
                    margin: 0 0 2px 0;
                    font-size: 0.85em;
                }

                .exam-type-value {
                    margin: 0;
                    font-weight: bold;
                    font-size: 0.95em;
                    color: #333;
                }

                .exam-type-content {
                    margin: 0;
                    font-size: 0.9em;
                    color: #333;
                }

                .admission-date {
                    margin: 0 0 8px 0;
                    font-size: 11pt;
                    text-transform: uppercase;
                }

                .admission-date strong {
                    display: inline-block;
                    min-width: 170px;
                    font-weight: 800;
                }

                /* Report Sections */
                .report-section {
                    margin-bottom: 4px;
                    page-break-inside: avoid;
                }

                .section-content {
                    margin-bottom: 2px;
                    font-size: 10.5pt;
                    line-height: 1.28;
                }

                /* Diagnosis Section with Highlight */
                .diagnosis-section {
                    page-break-inside: avoid;
                }

                .diagnosis-content {
                    background-color: transparent;
                    padding: 8px 0 0 0;
                    color: black;
                    font-weight: normal;
                    font-size: 12pt;
                    line-height: 1.25;
                    margin-bottom: 2px;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }

                /* Two-Column Wrapper */
                .report-wrapper {
                    display: grid;
                    grid-template-columns: 1fr 280px;
                    gap: 10px;
                    page-break-inside: avoid;
                    margin-bottom: 4px;
                }

                .report-wrapper--full {
                    grid-template-columns: 1fr;
                }

                /* Left Column: Main Content */
                .content-column {
                    flex: 1;
                    page-break-inside: avoid;
                }

                /* Right Column: Images */
                .images-column {
                    width: 280px;
                    page-break-inside: avoid;
                }

                .images-title {
                    margin: 0 0 8px 0;
                    font-size: 0.9em;
                    text-align: center;
                }

                .image-column {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                /* Grid Images (for >3) */
                .grid-images-section {
                    margin-bottom: 5px;
                    page-break-inside: avoid;
                }

                .image-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 6px;
                    page-break-before: auto;
                    page-break-inside: auto;
                    margin-bottom: 4px;
                }

                /* Image Item */
                .image-item {
                    page-break-inside: avoid;
                    display: block;
                }

                .image-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 128px;
                    border: none;
                    border-radius: 0;
                    background-color: #f5f5f5;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }

                .image-caption {
                    display: block;
                    min-height: 18px;
                    margin: 2px 0 0 0;
                    padding: 2px 4px;
                    background-color: #bfe7a3;
                    font-size: 0.78em;
                    line-height: 1.2;
                    color: #222;
                    text-align: center;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }

                /* Right column images smaller */
                .images-column .image-box {
                    height: 184px;
                }

                .images-column .image-box img {
                    object-fit: cover;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                }

                /* Signature and Seal Section */
                .signature-section {
                    margin-top: 10px;
                    page-break-inside: avoid;
                    break-inside: avoid;
                    clear: both;
                }

                .signature-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 0;
                }

                .signature-cell,
                .timestamp-cell {
                    padding: 4px 10px;
                    text-align: center;
                    vertical-align: top;
                    border: none;
                    width: 50%;
                }

                .signature-box {
                    position: relative;
                    width: 180px;
                    height: 68px;
                    margin: 0 auto 3px auto;
                }

                .signature-seal {
                    position: absolute;
                    left: 50%;
                    bottom: 7px;
                    transform: translateX(-50%);
                    max-width: 155px;
                    max-height: 58px;
                    object-fit: contain;
                }

                .signature-line {
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    width: 160px;
                    margin: 0 auto;
                    transform: translateX(-50%);
                    border-top: 1px solid #000;
                }

                .signature-name {
                    margin: 0 0 2px 0;
                    font-size: 0.85em;
                    font-weight: bold;
                }

                .signature-label {
                    font-size: 8px;
                    margin: 0;
                    color: #666;
                }

                .timestamp-label {
                    margin: 0 0 4px 0;
                    font-size: 0.8em;
                    font-weight: bold;
                }

                .timestamp-value {
                    margin: 0;
                    font-size: 0.9em;
                    font-family: 'Courier New', monospace;
                }

                .report-footer {
                    width: 100%;
                    position: fixed;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: 0;
                    padding: 0;
                    background: #fff;
                    page-break-before: auto;
                    page-break-inside: avoid;
                    break-inside: avoid;
                }

                .report-footer > * {
                    margin-top: 0 !important;
                    padding-top: 0 !important;
                }
            `
        },

        canPrintReport() {
            if (!this.form.id) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'Debes guardar el reporte primero'
                )
                return false
            }

            if (!this.$refs.dataprint || !this.$refs.dataprint.firstElementChild) {
                this.showAlert(
                    'danger',
                    'Error',
                    'No se encontró el contenido del reporte para imprimir'
                )
                return false
            }

            return true
        },

        waitForDelay(ms = 150) {
            return new Promise(resolve => {
                setTimeout(resolve, ms)
            })
        },

        waitForImages(images) {
            const imageList = Array.from(images || [])

            if (!imageList.length) {
                return Promise.resolve()
            }

            return Promise.all(imageList.map(image => new Promise(resolve => {
                if (image.complete && image.naturalWidth > 0) {
                    resolve()
                    return
                }

                let settled = false
                const finish = () => {
                    if (settled) return
                    settled = true
                    image.removeEventListener('load', finish)
                    image.removeEventListener('error', finish)
                    resolve()
                }

                image.addEventListener('load', finish, { once: true })
                image.addEventListener('error', finish, { once: true })
                setTimeout(finish, 5000)
            })))
        },

        async waitForPrintWindowReady(printWindow) {
            await new Promise(resolve => {
                let settled = false
                const finish = () => {
                    if (settled) return
                    settled = true
                    resolve()
                }

                if (printWindow.document.readyState === 'complete') {
                    finish()
                    return
                }

                printWindow.addEventListener('load', finish, { once: true })
                setTimeout(finish, 2000)
            })

            if (
                printWindow.document.fonts &&
                typeof printWindow.document.fonts.ready !== 'undefined'
            ) {
                try {
                    await printWindow.document.fonts.ready
                } catch (error) {
                    console.warn('No fue posible esperar las fuentes del documento', error)
                }
            }

            await this.waitForImages(printWindow.document.images)
            await this.waitForDelay()
        },

        buildPrintDocument(printContent) {
            return `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Reporte Clínico</title>
                    <style>${this.getPrintStyles()}</style>
                </head>
                <body>
                    ${printContent}
                </body>
                </html>
            `
        },

        createTemporaryPrintElement() {
            const source = this.$refs.dataprint.firstElementChild
            const wrapper = document.createElement('div')
            const page = source.cloneNode(true)

            wrapper.style.position = 'fixed'
            wrapper.style.left = '-10000px'
            wrapper.style.top = '0'
            wrapper.style.width = '216mm'
            wrapper.style.background = '#fff'
            wrapper.style.zIndex = '-1'
            wrapper.style.pointerEvents = 'none'
            wrapper.style.padding = '0'

            page.classList.add('page')
            page.style.display = 'block'
            page.style.width = '216mm'
            page.style.minHeight = '279mm'
            page.style.background = '#fff'
            page.style.padding = '12mm'

            wrapper.appendChild(page)
            document.body.appendChild(wrapper)

            return { wrapper, page }
        },

        closePrintWindow(printWindow) {
            if (!printWindow || printWindow.closed) {
                return
            }

            printWindow.close()
        },

        attachPrintWindowAutoClose(printWindow) {
            let closed = false

            const closeWindow = () => {
                if (closed) {
                    return
                }

                closed = true
                setTimeout(() => {
                    this.closePrintWindow(printWindow)
                }, 10)
            }

            // Cierre cuando se dispara afterprint (usuario presiona Imprimir o Cancelar)
            printWindow.addEventListener('afterprint', closeWindow, { once: true })

            // Fallback: Cierre automático después de 4 segundos si afterprint no se dispara
            // Esto captura cuando el usuario cancela el diálogo sin disparar afterprint
            setTimeout(() => {
                if (!closed && !printWindow.closed) {
                    closeWindow()
                }
            }, 4000)
        },

        getPrintWindowFeatures() {
            const width = window.screen.availWidth || window.innerWidth || 1280
            const height = window.screen.availHeight || window.innerHeight || 720

            return [
                'toolbar=no',
                'location=no',
                'status=no',
                'menubar=no',
                'scrollbars=yes',
                'resizable=yes',
                `width=${width}`,
                `height=${height}`,
                'left=0',
                'top=0'
            ].join(',')
        },

        maximizePrintWindow(printWindow) {
            if (!printWindow || printWindow.closed) {
                return
            }

            const width = window.screen.availWidth || window.innerWidth || 1280
            const height = window.screen.availHeight || window.innerHeight || 720

            try {
                printWindow.moveTo(0, 0)
                printWindow.resizeTo(width, height)
            } catch (error) {
                console.warn('No fue posible maximizar la ventana de impresión', error)
            }
        },

        async handlePrint() {
            if (!this.canPrintReport()) {
                return
            }

            const printContent = this.$refs.dataprint.innerHTML
            const printWindow = window.open('', '', this.getPrintWindowFeatures())

            if (!printWindow) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'El navegador bloqueó la ventana de impresión'
                )
                return
            }

            printWindow.document.open()
            printWindow.document.write(this.buildPrintDocument(printContent))
            printWindow.document.close()

            await this.waitForPrintWindowReady(printWindow)

            this.maximizePrintWindow(printWindow)
            printWindow.focus()
            this.attachPrintWindowAutoClose(printWindow)
            printWindow.print()
        },

        async loadReportsHistory() {
            if (!this.data) return
            
            try {
                this.historyData = await this.$API.clinicalreports.getAllreport(
                    this.data.ID_Patient
                )
                console.log(this.historyData);
                
            } catch (error) {
                console.log('Error loading reports:', error)
                this.showAlert(
                    'danger',
                    'Error',
                    'No se pudieron cargar los reportes históricos'
                )
            }
        },

        loadReportIntoForm(e) {
            if (e.data) {
                this.form = {
                    id: e.data.id,
                    date: e.data.Report_Date,
                    clinicalReportCorrelative: e.data.clinical_report_correlative || '',
                    patientName: e.data.PatientName,
                    patientSpecies: e.data.PatientSpecies,
                    patientBreed: e.data.PatientBreed,
                    patientGender: e.data.PatientGender,
                    patientDoctor: e.data.PatientDoctor,
                    referringDoctor: e.data.referring_doctor || '',
                    originVeterinary: e.data.origin_veterinary || '',
                    description: e.data.Description,
                    clinicalDiagnosis: e.data.ClinicalDiagnosis || '',
                    diagnosis: e.data.Diagnosis,
                    patientAge: e.data.PatientAge || this.calculatePatientAge(this.data.DateOfBirth),
                    patientAdmissionDate: e.data.PatientAdmissionDate || this.getPatientAdmissionDate(),
                    examType: e.data.ExamType || '',
                    manualExamType: '',
                    reportNumber: e.data.ReportNumber || ''
                }
                this.dialogHistory = false
            }
        },

        selectedPrint(e) {
            // Alias for loadReportIntoForm (compatibility)
            this.loadReportIntoForm(e)
        },

        async loadReportAndClose(report) {
            // Load the report into the form
            this.form = {
                id: report.id,
                date: report.Report_Date,
                clinicalReportCorrelative: report.clinical_report_correlative || '',
                patientName: report.PatientName,
                patientSpecies: report.PatientSpecies,
                patientBreed: report.PatientBreed,
                patientGender: report.PatientGender,
                patientDoctor: report.PatientDoctor,
                referringDoctor: report.referring_doctor || '',
                originVeterinary: report.origin_veterinary || '',
                description: report.Description,
                clinicalDiagnosis: report.ClinicalDiagnosis || '',
                diagnosis: report.Diagnosis,
                patientAge: report.PatientAge || this.calculatePatientAge(this.data.DateOfBirth),
                patientAdmissionDate: report.PatientAdmissionDate || this.getPatientAdmissionDate(),
                examType: report.ExamType || '',
                manualExamType: '',
                reportNumber: report.ReportNumber || ''
            }
            // Load associated images
            if (report.id) {
                await this.loadReportImages(report.id)
            }
            // Close the history dialog
            this.dialogHistory = false
        },

        openDeleteConfirm(report) {
            this.reportToDelete = report
            this.deleteConfirmDialog = true
        },

        async deleteReport() {
            if (!this.reportToDelete) {
                this.showAlert(
                    'warning',
                    'Advertencia',
                    'No hay reporte seleccionado para borrar'
                )
                return
            }

            this.saving = true
            try {
                await this.$API.clinicalreports.deletereport(this.reportToDelete.id)
                
                this.showAlert(
                    'success',
                    'Éxito',
                    'Reporte clínico eliminado correctamente'
                )

                // Close dialog and reload history
                this.deleteConfirmDialog = false
                this.reportToDelete = null
                await this.loadReportsHistory()
                
            } catch (error) {
                this.showAlert(
                    'danger',
                    'Error',
                    error || 'Error al eliminar el reporte'
                )
            } finally {
                this.saving = false
            }
        },

        showAlert(type, header, body, options = null) {
            type = type == null ? 'danger' : type
            this.alert.type = type
            this.alert.header = header
            this.alert.body = body
            this.alert.show = true
            this.alert.options = options != null ? options : null
        },

        closeAlert() {
            this.alert.show = false
        },

        acceptAlert() {
            this.alert.show = false
        },

        async handleImagesSelected(data) {
            // data contains { files, previews }
            
            // NEW REPORT: Store temporarily
            if (!this.form.id) {
                data.files.forEach((file, idx) => {
                    this.tempReportImages.push({
                        file: file,
                        preview: data.previews[idx],
                        image_description: (data.descriptions && data.descriptions[idx]) || ''
                    })
                })
                
                this.showAlert(
                    'success',
                    'Éxito',
                    `${data.files.length} imagen(es) agregada(s) temporalmente`
                )
                this.addImagesDialog = false
                return
            }

            // EXISTING REPORT: Upload immediately (current behavior)
            this.saving = true
            try {
                const formData = new FormData()
                const typeOfImage = 'Reportes clínicos'
                
                // Add files with types (matching VeterinaryImages.vue pattern)
                data.files.forEach(file => {
                    formData.append('file', file)
                    formData.append('types', typeOfImage)
                })
                formData.append('imageDescriptions', JSON.stringify(data.descriptions || []))

                // Add metadata
                formData.append('form', JSON.stringify({
                    ID_Patient: this.data.ID_Patient,
                    ImagesDate: new Date().toLocaleDateString('es-ES'),
                    TypeOfImage: typeOfImage,
                    ID_User_Insert: this.useData.id,
                    ID_Business: localStorage.businessName,
                    ID_Branch: localStorage.branchName
                }))

                const response = await this.$API.clinicalreportimages.addImagesToReport(
                    this.form.id,
                    formData
                )

                this.showAlert(
                    'success',
                    'Éxito',
                    `${response.filesCount} imágenes agregadas correctamente`
                )

                // Reload images
                await this.loadReportImages(this.form.id)
                this.addImagesDialog = false

            } catch (error) {
                this.showAlert(
                    'danger',
                    'Error',
                    error || 'Error al agregar imágenes'
                )
            } finally {
                this.saving = false
            }
        },

        async loadReportImages(reportId) {
            try {
                const images = await this.$API.clinicalreportimages.getImagesByReportId(reportId)
                this.clinicalReportImages = images || []
                console.log('Images loaded for report:', reportId, images)
            } catch (error) {
                console.error('Error loading images:', error)
                this.clinicalReportImages = []
            }
        },

        async deleteImage(imageData) {
            // Handle both saved and temporary images
            if (imageData.isTemp) {
                // Delete temporary image
                const idx = imageData.tempIndex
                this.tempReportImages.splice(idx, 1)
                this.showAlert(
                    'success',
                    'Éxito',
                    'Imagen temporal eliminada'
                )
                return
            }

            // Delete saved image (requires report to exist)
            if (!this.form.id) return

            try {
                await this.$API.clinicalreportimages.deleteRelationship({
                    ID_ClinicalReport: this.form.id,
                    ID_Image: imageData.ID_Image
                })

                this.showAlert(
                    'success',
                    'Éxito',
                    'Imagen eliminada correctamente'
                )

                // Reload images
                await this.loadReportImages(this.form.id)

            } catch (error) {
                this.showAlert(
                    'danger',
                    'Error',
                    error || 'Error al eliminar la imagen'
                )
            }
        },

        updateImageDescription(imageData, value) {
            if (imageData.isTemp) {
                if (typeof imageData.tempIndex !== 'undefined' && this.tempReportImages[imageData.tempIndex]) {
                    this.$set(this.tempReportImages[imageData.tempIndex], 'image_description', value)
                }
                return
            }

            const imageIndex = this.clinicalReportImages.findIndex(image => image.ID_Image === imageData.ID_Image)
            if (imageIndex >= 0) {
                this.$set(this.clinicalReportImages[imageIndex], 'image_description', value)
            }
        },

        openImageView(imagePath) {
            this.selectedImagePath = imagePath
            this.imageViewDialog = true
        }
    }
}
</script>

<style scoped>
.d-none {
    display: none;
}

.print-container {
    font-family: Arial, sans-serif;
}

.headline {
    font-size: 1.5rem;
    font-weight: 500;
}

.clinical-images-grid {
    width: 100% !important;
}

.history-datagrid {
    width: 100% !important;
}

.thumbnail-preview {
    max-width: 70px;
    max-height: 70px;
    height: auto;
    border-radius: 4px;
    object-fit: cover;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.thumbnail-preview:hover {
    transform: scale(1.05);
}

::v-deep .quill-wrapper--error .ql-container,
::v-deep .quill-wrapper--error .ql-toolbar {
    border-color: #ff5252 !important;
}

.validation-error {
    color: #ff5252;
    font-size: 12px;
    line-height: 1;
    margin-top: 4px;
}

::v-deep .print-btn.v-btn--disabled {
  background-color: #fcfcfc !important;
}

::v-deep .print-btn.v-btn--disabled .v-icon {
  color: white !important;
  opacity: 0.7;
}

</style>
